import ENDPOINTS from '@utils/apiEndpoints';
import { axiosInstance } from '@utils/axiosInstance';
import { isStaff } from '@utils/getRole';
import { onApiError, onApiSuccess } from '@utils/utilities';

export const customerDeliveryFileUploadInsertService = (
  data: any,
  signal: AbortSignal,
) => {
  const URL = isStaff
    ? ENDPOINTS.STAFF.CUSTOMER_DELIVERY.UPLOAD.INSERT
    : ENDPOINTS.ADMIN.CUSTOMER_DELIVERY.UPLOAD.INSERT;

  return axiosInstance
    .post(URL, data, { signal })
    .then((response) => {
      return onApiSuccess(response);
    })
    .catch((error) => {
      return onApiError(error);
    });
};
